import styled from "styled-components";
import { StatusItemProps } from ".";

export const DriveStatusItem = styled.li`
  display: flex;
  min-height: 60px;
  padding: 0 28px;
  color: ${(props) => props.theme.colors.primary100};
  font-size: 1.8rem;
  font-weight: 500;
  background: ${(props) => props.theme.colors.white100};
  border-radius: 6px;
  border: 1px solid ${(props) => props.theme.colors.black8};
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 0px 16px;
`;

export const DriveStatusLabel = styled.div<StatusItemProps>`
  display: flex;
  color: ${(props) => props.theme.colors.black80};
  font-size: 1.3rem;
  font-weight: 500;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;

  div {
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background: ${(props) => props.theme.colors[props.color]};
  }
`;
